const receivementsRoutes = [
    {
        path: "/receivements",
        name: "receivements",
        redirect: "receivements/LyndusPay",
        component: () => import("@/views/receivements/Receivements"),
        children: [
            {
                path: "/receivements/LyndusPay",
                name: "receivementsLyndusPay",
                component: () => import("@/views/receivements/LyndusPay")
            },
            {
                path: "/receivements/general",
                name: "receivementsGeneral",
                component: () => import("@/views/receivements/General")
            },

        ]
    }
]
export default receivementsRoutes